<template>
  <div class="success">
    <div class="t">
      <img src="../../assets/img/logo.png" alt />
      <span>习讯云-校企合作平台</span>
    </div>
    <div class="content">
      <div class="tip">支付成功！</div>
      <div class="info">
        <div class="t1">习讯-企校云平台</div>
        <div class="t2" style="color: #4090E6;">电脑登录网址：qxiaoyun.com</div>
        <div class="t2">校企合作/技能人才招聘一站式服务平台</div>
        <div class="t3">全国1000+学校&nbsp;&nbsp;&nbsp;&nbsp;100万+学生</div>
        <div class="t4">大数据精准匹配，开启您的校企合作之路</div>
      </div>
      <div class="rights">
        <div class="title">您获得如下权益：</div>
        <div>
          <span></span>招聘岗位在线发布给全校学生，学生随时随地在线应聘
        </div>
        <div>
          <span></span>学校校企合作、校园招聘、毕业生推荐等优先合作推荐
        </div>
        <div>
          <span></span>每年第一时间获取学校招聘通知，免去频繁出差跑学校的麻烦
        </div>
        <div>
          <span></span>应往届毕业生人才全网推荐匹配，节省企业招聘成本
        </div>
        <div>
          <span></span>优先共享推荐校企合作平台全网数百所学校及其学生资源
        </div>
        <div>
          <span></span>平台为您构建企业人力资源储备库，丰富毕业生人才简历资源
        </div>
      </div>
      <div class="back">
        <el-button type="primary" @click="backJob">返回岗位列表</el-button>
      </div>
    </div>
    <div class="wx">
      <div>
        <span>习讯公众号</span>
        <img src="../../assets/img/qrcode/xixun.jpg" alt />
      </div>
      <div>
        <span>企校云小程序</span>
        <img src="../../assets/img/qrcode/qxy.jpg" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    backJob() {
      this.$router.push("/schoolJobList");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.success {
  padding-bottom: 200px;
  .t {
    display: flex;
    align-items: center;
    padding: 20px 0 0 100px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
    span {
      font-size: 30px;
    }
  }
  .content {
    width: 500px;
    margin: 50px auto 0;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 50px;
    .tip {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
    }
    .rights {
      margin: 40px 0;
      line-height: 1.5;
      .title {
        margin: 0 0 15px 0;
        font-weight: bold;
      }
      div span {
        display: inline-block;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #4b7ff7;
        margin-right: 10px;
      }
    }
    .info {
      text-align: center;
      .t1 {
        font-size: 25px;
        font-weight: bold;
        margin-top: 30px;
      }
      .t2 {
        margin-top: 10px;
        font-size: 20px;
      }
      .t3 {
        margin-top: 40px;
        color: $blue;
        font-size: 25px;
        font-weight: bold;
      }
      .t4 {
        margin-top: 10px;
        color: $blue;
        font-size: 20px;
      }
    }
    .back {
      text-align: center;
    }
  }
  .wx {
    width: 400px;
    margin: 100px auto 0;
    display: flex;
    justify-content: space-between;
    & > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-weight: bold;
      span {
        margin-bottom: 10px;
      }
      img {
        width: 150px;
        height: 150px;
      }
    }
  }
}
</style>